/**
 * Created by hiral on 2/11/17.
 */

import { Component, Input, OnInit } from '@angular/core';
import { BaseFilterCellComponent, FilterService } from '@progress/kendo-angular-grid';
import { Subject } from 'rxjs/Subject';

@Component({
  selector: 'app-kendo-string-filter',
  template: `
    <div class="k-filtercell-wrapper">
      <input type="text" class="k-textbox" [id]="field" [attr.aria-label]="ariaLabel || 'Filter by ' + field" [(ngModel)]="value" (input)="callFilter($event)"/>
    </div>
  `
})
export class KendoStringFilterComponent extends BaseFilterCellComponent implements OnInit {
    // in the template
   // <div class="k-filtercell-wrapper">
    //   <label [for]="field" class="sr-only">{{ariaLabel || 'Filter by ' + field}}</label>
    //   <input type="text" class="k-textbox" [id]="field" [attr.aria-label]="ariaLabel" [attr.title]="ariaLabel || 'Filter by ' + field" [(ngModel)]="value" (input)="callFilter($event)"/>
    // </div>
  @Input() public filter: any;
  @Input() public sort: any;
  @Input() public data: any[];
  @Input() public field: string;
  @Input() public column: any;
  @Input() clearInputValue: Subject<any>;
  @Input('aria-label') ariaLabel: string;
  @Input() title: string;
  public value: string;


  constructor(filterService: FilterService) {
    super(filterService);
  }

  ngOnInit(): void {
    if (this.clearInputValue) {
      this.clearInputValue.subscribe(event => {
        this.resetFilter();
      });
    }
  }

  public callFilter(event: any): void {
    const givenString = this.value;
    if (event.type === 'input' || event.keyCode === 13 || (!givenString && event.keyCode !== 9)) {
      this.applyFilter(
        (givenString === null || givenString === '') ?
          this.removeFilter(this.field) :
          this.updateFilter({
            field: this.field,
            operator: 'contains',
            value: givenString
          })
      );
    }
  }

  public resetFilter(): any {
    this.value = '';
    this.applyFilter(
      this.removeFilter(this.field)
    );
  }
}
